export const getUser = (state) => state.auth.user;
